import Vue from 'vue'
import Router from 'vue-router'
import index from '../views/index/index'
import indexContent from '../views/index/indexContent'
import visitor from '../views/visitor/visitor'
import feedback from '../views/feedback/feedback'
import waitTask from '../views/feedback/child/waitTask'
import processed from '../views/feedback/child/processed'
import waitParticular from '../views/feedback/child/waitParticular'
import proParticular from '../views/feedback/child/proParticular'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'index',
      redirect: '/index'
      // component:index,
    },
    {
      path: '/index',
      name: '平安校园管理系统',
      component: index,
      children: [
        {path: '', name: '列表', component: indexContent},
        {path: 'visitorRecord', name: '校园访客记录', component: visitor},
        {path: 'feedback',
          name: '问题反馈',
          component: feedback,
          redirect: 'feedback/waitTask',
          children: [
            {path: 'waitTask', name: 'waitTask', component: waitTask},
            {path: 'processed', name: 'processed', component: processed},
            {path: 'waitParticular', name: 'waitParticular', component: waitParticular},
            {path: 'proParticular', name: 'proParticular', component: proParticular}
          ]
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js